import React from "react";

export default (props) => (
    <i className={`sprite sprite-ai-round`} />
);
